export function datepicker() {
    document.addEventListener("DOMContentLoaded", function () {

        $(".datepicker").on("focus", function () {
            let fiedlWidth = $(this).outerWidth();

            setTimeout(function (){
                $(".ui-datepicker").css("width", fiedlWidth);
            },100);
        });
        $(".datepicker").each(function (inden, el) {
            $(el).datepicker();
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/datepicker.js